import { IssueEntity } from '../issue/entity';

/** The number shown for each issue, by its id: a version's source issue (PT-7117) is shown by its number. */
export const createIssueNumberMap = (issues: IssueEntity[]): Map<string, string> =>
  new Map(
    issues.flatMap(({ _id, issueNumberSearch }) => {
      const issueId = String(_id ?? '').trim();
      const issueNumber = String(issueNumberSearch ?? _id ?? '').trim();
      return issueId && issueNumber ? [[issueId, issueNumber] as const] : [];
    })
  );
